var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
import url from 'url';
var defaultUrl = url.format({
    pathname: '/api/navigation/',
});
export var useMenu = function (_a) {
    var navigationUrl = _a.navigationUrl, getNavigation = _a.getNavigation, navigationRequestOptions = _a.navigationRequestOptions, hideMenu = _a.hideMenu;
    var _b = __read(useState([]), 2), menu = _b[0], setMenu = _b[1];
    var _c = __read(useState(true), 2), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        if (menu.length || hideMenu)
            return;
        fetch(navigationUrl || defaultUrl, __assign({ credentials: 'include', mode: 'cors' }, navigationRequestOptions))
            .then(function (result) { return result.json(); })
            .then(function (pages) {
            if (typeof getNavigation === 'function')
                getNavigation(pages);
            var menu = pages.map(function (page) { return (__assign(__assign({}, page), { to: page.path })); });
            setMenu(menu);
        })
            .catch(console.error)
            .finally(function () { return setLoading(false); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menu, getNavigation, navigationUrl, hideMenu]);
    return {
        menu: menu.filter(function (page) { return !page.disabled; }),
        disabledMenu: menu.filter(function (page) { return page.disabled; }),
        defaultMenu: menu,
        loading: loading,
    };
};
//# sourceMappingURL=useMenu.js.map